import { cx } from '../../utils/cx'
import css from '../../styles/EditorV2.module.css'

/**
 * The Figma segmented control ("segment control" component): a #F1F3F5 (or #F8F9FA) track
 * with 4px padding, items separated by hairlines, the active item white with a 2px pink
 * ring. Used for the Editor/Chat tabs, Clickout, Source, Identity and the format switcher.
 *
 * options: [{ value, label, icon?, suffix?, disabled?, title? }]
 */
export function Segmented({
  value,
  onChange,
  options,
  size = 'md',
  fill = 'track',
  stack = false,
  fullWidth = false,
  disabled = false,
  ariaLabel,
  className,
  itemClassName,
  style,
}) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className={cx(css.segment, className)}
      data-size={size}
      data-fill={fill === 'light' ? 'light' : undefined}
      data-stack={stack ? 'true' : undefined}
      style={{ ...(fullWidth ? { display: 'grid', width: '100%' } : null), ...style }}
    >
      {options.map((option) => {
        const active = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            data-active={active ? 'true' : 'false'}
            className={cx(css.segmentItem, itemClassName)}
            disabled={disabled || option.disabled}
            title={option.title}
            onClick={() => { if (!active) onChange?.(option.value) }}
          >
            {option.icon}
            <span>{option.label}</span>
            {option.suffix}
          </button>
        )
      })}
    </div>
  )
}
